import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { LYZI_GOODS_CATEGORY, LYZI_GOODS_TYPE, LYZI_ENVIRONMENT } from '../../../constants';

import { payWithLyzi } from '../../../services/lyzi/actions';

import { getI18nByApp } from '../../../services/i18n/selector';

import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import ButtonComponent from '../../button/ButtonComponent';
import { LoadingComponent } from '../../loading/LoadingComponent';

import { LyziIframeContainer } from './LyziIframeStyle';

const LyziIframe = ({
    userInfo,
    partnerId,
    partnerName,
    order,
    cartTotalValue,
    i18nMulti,
    payWithLyzi,
    lyziFetchingPay,
    lyziErrorPay,
    lyziFormResponse
}) => {
    useEffect(() => {
        payWithLyzi(userInfo, partnerId, order.id);
    }, []);

    useEffect(() => {
        if (lyziFormResponse && lyziFormResponse.buttonId) {
            createFormLyzi();
        }
    }, [lyziFormResponse]);

    const createFormLyzi = () => {
        setTimeout(() => {
            window.lyziBuyButton.init(
                {
                    buttonId: lyziFormResponse.buttonId,
                    buttonName: getI18nByApp(i18nMulti, 'common.EBON'),
                    orderRef: order.id,
                    price: cartTotalValue,
                    goods: {
                        goodsName: `${partnerName}`,
                        goodsCategory: LYZI_GOODS_CATEGORY,
                        goodsType: LYZI_GOODS_TYPE
                    },
                    env: LYZI_ENVIRONMENT,
                    callbackUrl: lyziFormResponse.callbackUrl,
                    returnUrl: lyziFormResponse.successUrl,
                    cancelUrl: lyziFormResponse.errorUrl
                },
                document.getElementById('button-pay-crypto')
            );
        }, 100);
    };

    return (
        <LyziIframeContainer>
            {lyziFetchingPay && (
                <div className="loading">
                    <LoadingComponent />
                </div>
            )}

            {!lyziFetchingPay && (
                <div className="lyzi-wrapper">
                    {!lyziErrorPay ? (
                        <React.Fragment>
                            <p>{getI18nByApp(i18nMulti, 'page.EBON.CRYPTO.TEXT_1')}</p>
                            <ButtonComponent
                                id="button-pay-crypto"
                                color="main"
                                text={getI18nByApp(i18nMulti, 'page.EBON.CRYPTO.BUTTON_TEXT')}
                            />
                        </React.Fragment>
                    ) : (
                        <p>{convertHtmlToReactDomWithParams(lyziErrorPay)}</p>
                    )}
                </div>
            )}
        </LyziIframeContainer>
    );
};

LyziIframe.propTypes = {
    userInfo: PropTypes.object,
    partnerId: PropTypes.number,
    partnerName: PropTypes.string,
    order: PropTypes.object,
    cartTotalValue: PropTypes.number
};

const mapStateToProps = state => {
    return {
        i18nMulti: state.i18n,
        lyziFormResponse: state.lyzi.formResponse,
        lyziErrorPay: state.lyzi.errorPay,
        lyziFetchingPay: state.lyzi.fetchingPay
    };
};

const mapDispatchToProps = {
    payWithLyzi
};

export default connect(mapStateToProps, mapDispatchToProps)(LyziIframe);



// WEBPACK FOOTER //
// ./src/components/iframes/lyzi/LyziIframe.js